import {
  Container,
  Typography,
  Box,
  LinearProgress,
  Alert,
  AlertTitle,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { dictionaryService, Token } from './services/dictionaryService';
import FormPagePerson from './FormPagePerson';
import FormPageB2B from './FormPageB2B';

export interface ContactDetails {
  firstName: string;
  lastName: string;
  email: string;
  phoneNo: string;
}

const FormPage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [errorType, setErrorType] = useState<string | null>(null);
  const [tokenAll, setTokenAll] = useState<Token | null>(null);
  const [contactDetails, setContactDetails] = useState<ContactDetails | null>(null);
  const [formType, setFormType] = useState<string | null>(null);
  const [mail, setMail] = useState<string | null>(null)
  const updateFavicon = (iconPath: string) => {
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.href = iconPath;
};

  useEffect(() => {
    const fetchData = async () => {
        if (!window.location.hostname.includes('brandlift')) {
            updateFavicon(`${process.env.PUBLIC_URL}/favi-sparkyB.png`); // favicon dla SparkyB
            setMail("hello@sparkyb.pl")
        } else {
            updateFavicon(`${process.env.PUBLIC_URL}/favi-brandlift.png`); // favicon dla Brandlift
            setMail("hello@brandlift.pl")
        }
      if (!token) {
        setLoading(false);
        setErrorType('missing');
        return;
      }

      try {
        const data = await dictionaryService.getFormByToken(token);
        setTokenAll(data.token);
        setFormType(data.formType);
        setContactDetails(data.contactDetails);
      } catch (error: unknown) {
        let serverError;
        type ErrorResponse = {
          response?: {
            data?: {
              error?: string;
            };
          };
        };
        if (
          typeof error === 'object' &&
          error !== null &&
          'response' in error &&
          typeof (error as ErrorResponse).response === 'object' &&
          (error as ErrorResponse).response !== undefined &&
          'data' in (error as ErrorResponse).response! &&
          typeof (error as ErrorResponse).response!.data === 'object' &&
          (error as ErrorResponse).response!.data !== undefined &&
          'error' in (error as ErrorResponse).response!.data!
        ) {
          serverError = (error as ErrorResponse).response!.data!.error;
        }

        if (serverError === 'form_outdated') {
          setErrorType('expired');
        } else if (serverError === 'incorrect_token') {
          setErrorType('incorrect');
        } else if (serverError === 'form_already_submitted') {
          setErrorType('used');
        } else {
          setErrorType('server'); // fallback na brak konkretnego błędu
        }
      }
      finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);


  const renderError = () => {
    switch (errorType) {
      case 'expired':
        return (
          <Alert severity="warning" sx={{ mt: 10 }}>
            <AlertTitle>Przedatowany token</AlertTitle>
            Ups! Troszeczkę za długo to trwało, a względy bezpieczeństwa są nieubłagane. Musimy wygenerować dostęp do formularza jeszcze raz. Napisz do nas na adres mailowy {mail},  a otrzymasz mail z linkiem do nowego formularza. Tym razem na pewno się uda !
            {/*<Box mt={2}>*/}
            {/*  <Button variant="contained">Wyślij formularz ponownie</Button>*/}
            {/*</Box>*/}
          </Alert>
        );
      case 'incorrect':
        return (
          <Alert severity="error" sx={{ mt: 10 }}>
            <AlertTitle>Niepoprawny token</AlertTitle>
                    Hmmm… coś poszło nie tak. Musimy wygenerować dostęp do formularza jeszcze raz. Napisz do nas na {mail}, a otrzymasz na maila link do nowego formularza. Tym razem na pewno się uda!
                    <strong style={{ marginInline: '5px' }}>
                      <a href={`mailto:${mail}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
                        {mail}
                      </a>
            </strong>
            a spróbujemy rozwiązać problem od ręki.
          </Alert>
        );
      case 'used':
        return (
          <Alert severity="error" sx={{ mt: 10 }}>
            <AlertTitle>Formularz został już użyty</AlertTitle>
            Hmmm… wygląda na to, że ten formularz został już raz użyty.
            Napisz do nas na adres mailowy
            <strong style={{ marginInline: '5px' }}>

              <a href={`mailto:${mail}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
                  {mail}
              </a>
            </strong>
            a spróbujemy rozwiązać problem od ręki.
          </Alert>
        );
      case 'server':
        return (
          <Alert severity="error" sx={{ mt: 10 }}>
            <AlertTitle>Brak odpowiedzi ze strony serwera</AlertTitle>
            Halo, halo? Czy my się słyszymy? Mamy jakiś chwilowy problem techniczny z kontaktem z bazą.
            <strong style={{ marginInline: '5px' }}>

              <a href={`mailto:${mail}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
                  {mail}
              </a>
            </strong>
            a spróbujemy rozwiązać problem komunikacji od ręki.
          </Alert>
        );
      case 'missing':
        return (
          <Alert severity="error" sx={{ mt: 10 }}>
            <AlertTitle>Brak tokenu</AlertTitle>
            Nie znaleziono tokenu w linku. Proszę sprawdzić adres lub poprosić o nowy link.
          </Alert>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          height: '62px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #00D2B4',
          padding: '0 16px',
          backgroundColor: 'white',
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ height: '30px', marginLeft: { xs: '1vw', md: '20px' }, marginTop: '8px' }}
        >
          {!window.location.hostname.includes('brandlift') ? (
            <img
              src={`${process.env.PUBLIC_URL}/SPARKYB.png`}
              alt="Sparky Logo"
              style={{ width: '200px', height: 'auto', marginTop: '-45px' }}
            />
          ) : (
            <img src={`${process.env.PUBLIC_URL}/logo.png`}
                 alt="Logo" />
          )}
        </Typography>

        {loading && (
          <LinearProgress
            sx={{
              height: 3,
              width: '100%',
              position: 'absolute',
              bottom: 0,
              left: 0,
              backgroundColor: '#00D2B4',
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#B2DFDB',
              },
            }}
          />
        )}
      </Box>

      <Container maxWidth="lg">
        {loading ? (
          <Alert severity="info" sx={{ mt: 10 }}>
            <AlertTitle>Ładowanie danych</AlertTitle>
            Trwa weryfikacja tokenu oraz ładowanie formularza. Proszę czekać...
          </Alert>
        ) : errorType ? (
          renderError()
        ) : contactDetails !== undefined && contactDetails !== null && tokenAll ? (
          <>
            {formType === 'PERSONAL' ? (
              <FormPagePerson tokenAll={tokenAll} contactDetails={contactDetails} />
            ) : (
              <FormPageB2B tokenAll={tokenAll} contactDetails={contactDetails} />
            )}
          </>
        ) : null}
      </Container>
    </>
  );
};

export default FormPage;
